import React, { useEffect, useState } from "react";
import '../../../styles/Header-css/ServicePartner/PartnerVerification/KycStep.css';
import {
  kycVerification
} from "../../../../api/partner/kyc";
const KycStep = ({ data, onDataChange, onBack, onNext, errors }) => {
    const [saving, setSaving] = useState(false);
  const handleSubmit = async(e) => {
    e.preventDefault();
   // onNext();
     try {
              setSaving(true);
              await kycVerification(data.idType, data.idNumber);
              onNext();
            } catch (err) {
              console.error("KYC Details save failed", err);
              alert("Failed to save kyc details. Please try again.");
            } finally {
              setSaving(false);
            }
  };

  const handleInputChange = (e) => {
   const { name, value, files } = e.target;

    // File upload is optional – store only if selected
    if (name === "idUpload") {
      onDataChange({
        target: { name, value: files?.[0] || null },
      });
    } else {
      onDataChange(e);
    }
  };

  return (
    <>
      <h2>KYC Verification</h2>

      {/* Card */}
      <div className="onboarding-card">
        <h3>Identity Verification</h3>
        <p>Verify your identity to continue with Ready2Rental</p>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit}>
        {/* ID Type */}
        <div className="onboarding-form-group">
          <label htmlFor="idType">ID Type *</label>
          <select
            name="idType"
            id="idType"
            className="onboarding-form-control"
            value={data.idType || ""}
            onChange={handleInputChange}
            required
          >
            <option value="">Select ID Type</option>
            <option value="aadhaar">Aadhaar Card</option>
            <option value="pan">PAN Card</option>
            <option value="driving">Driving License</option>
            <option value="voter">Voter ID</option>
            <option value="passport">Passport</option>
          </select>
          {errors.idType && (
            <div className="onboarding-error-message">{errors.idType}</div>
          )}
        </div>

        {/* ID Number */}
        <div className="onboarding-form-group">
          <label htmlFor="idNumber">ID Number *</label>
          <input
            type="text"
            name="idNumber"
            id="idNumber"
            className="onboarding-form-control"
            placeholder="Enter your ID number"
            value={data.idNumber || ""}
            onChange={handleInputChange}
            required
          />
          {errors.idNumber && (
            <div className="onboarding-error-message">{errors.idNumber}</div>
          )}
        </div>

        {/* Upload */}
        <div className="onboarding-form-group">
          <label htmlFor="idUpload">Upload ID Document *</label>
          <input
            type="file"
            name="idUpload"
            id="idUpload"
            className="onboarding-form-control"
            onChange={handleInputChange}
            accept=".jpg,.jpeg,.png,.pdf"
            required
          />
          <small className="onboarding-file-hint">
            Accepted formats: JPG, PNG, PDF (Max 5MB)
          </small>
          {errors.idUpload && (
            <div className="onboarding-error-message">{errors.idUpload}</div>
          )}
        </div>

        {/* Buttons */}
        <div className="onboarding-button-group">
          <button
            type="button"
            className="onboarding-btn onboarding-btn-secondary"
            onClick={onBack}
          >
            Back
          </button>
          <button
            type="submit"
            className="onboarding-btn onboarding-btn-primary"
          >
            Next: Verification
          </button>
        </div>
      </form>
    </>
  );
};

export default KycStep;